import React from 'react';
import styled from 'styled-components';

import { PreviewActive } from '@/assets/icons';

interface IViewAction {
  href: string;
  className?: string;
}

const ViewAction = ({ href, className }: IViewAction): React.ReactElement => {
  return (
    <a className={className} href={href} target="_blank" download rel="noreferrer">
      <ButtonView src={PreviewActive} />
    </a>
  );
};

export { ViewAction };

const ButtonView = styled.img`
  height: 17px;
  width: 100%;
`;
